export default __webpack_public_path__ + "static/media/GIS(GENERAL INFO. SHEET) 2022.4db0d711.pdf";